import type {
  IApiGetPerformanceMetricsRes,
  IApiPerformanceMetricsCounters,
  IApiPerformanceMetricsLp,
  IApiPerformanceMetricsServer,
} from '@cbridge-packages/api';
import type {
  IMetricCounters,
  IPerformanceMetricsData,
  IPerformanceMetricsLp,
  IPerformanceMetricsServer,
} from './performanceMetrics.interface';

export namespace PerformanceMetricsTranslator {
  export function fromApi(response: IApiGetPerformanceMetricsRes): IPerformanceMetricsData {
    return {
      servers: response.servers.map(fromApiServer),
      lps: response.lps.map(fromApiLp),
    };
  }

  function fromApiServer(server: IApiPerformanceMetricsServer): IPerformanceMetricsServer {
    return {
      id: server.id,
      name: server.name,
      counters: fromApiCounters(server.orderCounters),
    };
  }

  function fromApiLp(lp: IApiPerformanceMetricsLp): IPerformanceMetricsLp {
    return {
      id: lp.id,
      name: lp.name,
      counters: fromApiCounters(lp.quoteCounters),
    };
  }

  function fromApiCounters(counters: IApiPerformanceMetricsCounters): IMetricCounters {
    return {
      current: counters.perSecond.lastSecond,
      lastMinute: counters.perSecond.lastMinute,
      lastHour: counters.perSecond.lastHour,
      lastDay: counters.perSecond.lastDay,
    };
  }
}
